import React from 'react';
export const FooterElementUrl = props => {
    const { url, text } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: 'list-inline-item me-xl-2 w-auto mb-0 align-items-center d-flex' },
            React.createElement("a", { href: url, title: text, target: "_blank" }, text))));
};
